ShopTheme.login = (function () {
	function init() {
		var recoverPasswordLink = document.getElementById("RecoverPassword");
		var recoverPasswordForm = document.getElementById("RecoverPasswordForm");
		var hideRecoverPasswordForm = document.getElementById(
			"HideRecoverPasswordLink"
		);
		var successPanel = document.getElementById("successPanel");
		var successEmailDisplay = document.querySelector(".success-email-display");
		var emailInput = document.getElementById("RecoverEmail");
		var resetPanel = document.getElementById("resetPanel");

		// Function to show the password recovery form
		function showRecoverPasswordForm() {
			ShopTheme.Global.toggleVisibility(recoverPasswordForm, true);
			ShopTheme.Global.toggleOverlay(true);
		}

		// Function to hide the password recovery form
		function hideRecoverPasswordFormAction() {
			ShopTheme.Global.toggleVisibility(recoverPasswordForm, false);
			ShopTheme.Global.toggleOverlay(false);
			ShopTheme.Global.toggleVisibility(successPanel, false);
			ShopTheme.Global.toggleVisibility(resetPanel, true);
		}

		// Event listener for 'RecoverPassword' link
		recoverPasswordLink.addEventListener("click", function (event) {
			event.preventDefault();
			showRecoverPasswordForm();
		});

		// Event listener for closing the password recovery form
		hideRecoverPasswordForm.addEventListener("click", function (event) {
			event.preventDefault();
			hideRecoverPasswordFormAction();
		});

		// Event listener for form submission
		recoverPasswordForm.addEventListener("submit", function () {
			localStorage.setItem("submittedEmail", emailInput.value);
		});

		// Check if the URL fragment is '#recover' or if the success indicator is present
		if (
			window.location.hash === "#recover" ||
			successPanel.classList.contains("success-indicator")
		) {
			showRecoverPasswordForm();

			// Display email in success message
			var submittedEmail = localStorage.getItem("submittedEmail");
			if (submittedEmail) {
				successEmailDisplay.textContent = submittedEmail;
			}
		}
	}

	// Public API
	return {
		init: init,
	};
})();

document.addEventListener("DOMContentLoaded", ShopTheme.login.init);
